import { DownloadOutlined } from "@ant-design/icons";
import { BACKEND_URL } from "../Backend";
import { Button } from "antd";

function BotonDescargarPDF({ alumno, nombreArchivo  }) {
  const url = `${BACKEND_URL}/descargar/${encodeURIComponent(alumno.nombre_carrera)}/${encodeURIComponent(alumno.cuatrimestre_grupo)}/${encodeURIComponent(alumno.nombre_alumno)}/${encodeURIComponent(nombreArchivo)}`;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
<Button
        type="primary"
        icon={<DownloadOutlined />}
        style={{
          width: '100%',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          boxShadow: '0 4px 8px rgba(24, 144, 255, 0.3)',
          borderRadius: '6px',
          fontWeight: '600',
          fontSize: '16px',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#40a9ff';
          e.currentTarget.style.borderColor = '#40a9ff';
          e.currentTarget.style.boxShadow = '0 6px 12px rgba(64, 169, 255, 0.4)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#1890ff';
          e.currentTarget.style.borderColor = '#1890ff';
          e.currentTarget.style.boxShadow = '0 4px 8px rgba(24, 144, 255, 0.3)';
        }}
      >
        Descargar PDF
      </Button>    </a>
  );
}
export default BotonDescargarPDF;